import { useState } from "react";
import { Link } from "react-router-dom";
import { environment } from "../../../consts";
import RequestAccessModal from "../Modals/RequestAccessModal";
import "./FooterSection.scss";

const FooterSection = () => {
  const [modalOpen, setModalOpen] = useState(false);

  return (
    <footer className="footer-section">
      <img
        src="/LandingPageImages/Logo.svg"
        alt="EduBlock Pro"
        className="footer-logo"
      />
      <div className="footer-content-main">
        <div className="footer-content">
          <div className="footer-social-section">
            <div className="footerLftSection">
              <p className="footer-content-text">
                Explain how blockchain ensures secure and tamper-proof records
                of <span>achievements and qualifications.</span>
              </p>
            </div>
            <div className="footerRytSection">
              <div className="footer-navigation">
                {/* <Link to={environment.LANDING_PAGE || "/"} className="footer-link">Home</Link> */}
                <Link
                  to="#"
                  onClick={(e) => {
                    e.preventDefault();
                    window.scrollTo({ top: 0, behavior: "smooth" });
                  }}
                  target="_blank"
                  className="hover:text-cyan-400 transition-colors footer-link"
                >
                  Home
                </Link>

                {/* <Link
                  to={environment.STUDENT_PORTAL ? `${environment.STUDENT_PORTAL}sign-up` : "/student/sign-up"}
                  className="footer-link"
                  target="_blank"
                >
                  Candidate Registration
                </Link>
                <Link
                  to={environment.ADMIN_PORTAL}
                  className="footer-link"
                  target="_blank"
                >
                  Admin Portal
                </Link> */}
                <Link
                  to="#"
                  className="footer-link"
                  onClick={(e) => {
                    e.preventDefault();
                    setModalOpen(true);
                  }}
                >
                  Exam Authority Registration
                </Link>
                <Link
                  to="#"
                  className="footer-link"
                  target="_blank"
                  onClick={(e) => {
                    e.preventDefault();
                    window.scrollTo({ top: 0, behavior: "smooth" });
                  }}
                >
                  Contact
                </Link>
              </div>
              <div className="footer-social">
                <a
                  href="https://www.instagram.com/edublock.pro/?hl=en"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img src="/LandingPageImages/Instagram.svg" alt="Instagram" />
                </a>
                {/* <a
                  href="https://facebook.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="social-link social-facebook"
                  aria-label="Facebook"
                >
                  <img src="/LandingPageImages/Facebook.svg" alt="Facebook" />
                </a>
                <a
                  href="https://twitter.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="social-link social-twitter"
                  aria-label="Twitter"
                >
                  <img src="/LandingPageImages/twitter.svg" alt="Twitter" />
                </a> */}
              </div>
            </div>
          </div>
        </div>

        {/* Footer Bottom */}
        <div className="footer-bottom">
          <div className="footer-contact-left">
            <a
              href="mailto:contact@edublockpro.com"
              className="footer-email-large"
            >
              contact@edublockpro.com
            </a>
          </div>
          <div className="footer-bottom-section">
            <div className="footer-bottom-left">
              <span className="footer-copyright">© All rights Reserved</span>
              <Link to="#" className="footer-legal-link">
                Privacy policy
              </Link>
              <Link to="#" className="footer-legal-link">
                Terms of Service
              </Link>
            </div>
            <div className="footer-bottom-right-section">
              <div className="footer-address">
                <p className="address-line">Mohali, Punjab</p>
                <p className="address-line">C 208, Phase 8B, Industrial Area</p>
                <p className="address-line">
                  Sector 74, Sahibzada Ajit Singh Nagar
                </p>
                <a href="tel:8283977734" className="footer-phone-link">
                  {/* (082) 839-77-73 */}
                  +91-8283977734
                </a>
              </div>
              <div className="footer-bottom-right">
                <span className="footer-created">Created</span>
                <img
                  src="/LandingPageImages/AntierLogo.svg"
                  alt="Antier Solutions"
                  className="footer-company-logo"
                />
                <span className="footer-company-name">
                  Antier Solutions Pvt. Ltd.
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <RequestAccessModal
        open={modalOpen}
        onClose={() => setModalOpen(false)}
      />
    </footer>
  );
};

export default FooterSection;
